var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "url(#paint0_linear_5169_8246)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5169_8246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43 40H45V42H25V40H27V33C27 30.8783 27.8429 28.8434 29.3431 27.3431C30.8434 25.8429 32.8783 25 35 25C37.1217 25 39.1566 25.8429 40.6569 27.3431C42.1571 28.8434 43 30.8783 43 33V40ZM41 40V33C41 31.4087 40.3679 29.8826 39.2426 28.7574C38.1174 27.6321 36.5913 27 35 27C33.4087 27 31.8826 27.6321 30.7574 28.7574C29.6321 29.8826 29 31.4087 29 33V40H41ZM32 44H38V46H32V44Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5169_8246",
    x1: 80.5329,
    y1: 19.6874,
    x2: 42.2152,
    y2: 20.0353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBE5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#FC5059"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5169_8246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(23 23)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifyIcon);
export default __webpack_public_path__ + "static/media/notify_icon.847aa8e69cd4b6e1f227b291cdf7e7d0.svg";
export { ForwardRef as ReactComponent };